/**
 * 我的学习模块：学习资源与个人课程的统一入口。
 *
 * 未登录时页面给出登录引导，不做强制跳转。
 */

import { UserRound } from '@lucide/vue'
import type { PortalModule } from '@/shell/module-registry'

const basePath = '/me'

export const meModule: PortalModule = {
  key: 'me',
  title: '我的学习',
  icon: UserRound,
  basePath,
  order: 30,
  defaultPath: basePath,
  nav: [{ label: '我的学习', to: basePath }],
  routes: [
    {
      path: 'profile',
      name: 'me-profile',
      component: () => import('./pages/ProfileHome.vue'),
    },
    {
      path: '',
      component: () => import('./pages/MyLearningHome.vue'),
      children: [
        {
          path: '',
          name: 'me-learning',
          component: () => import('./pages/MyLearningResources.vue'),
        },
        {
          path: 'courses',
          name: 'me-courses',
          component: () => import('./pages/MyCourses.vue'),
        },
      ],
    },
  ],
}
